import React from 'react'
import './UserConfig.css'
import { useNavigate } from 'react-router-dom';
import Adminnav from '../Adminnav';
const UserConfig = () => {

  var nav = useNavigate()
  function navSellerConfig(){
    nav('/AdminPanel/UserConfig/SellerConfig')
  }
  function navDistributionHub(){
    nav('/AdminPanel/UserConfig/DistributionHubConfig')
  }

  return (
      <>
      <Adminnav/>
   <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-store col icons"  onClick={()=>navSellerConfig()}></i>
                <i className="fas fa-warehouse col icons" onClick={()=>navDistributionHub()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>Seller Configuration</b>
                <b className="col" style={{marginLeft:"25px"}}>Distribution Hub Configuration</b>
                </div>
            </div>
    </>
  )
}

export default UserConfig